import { useHistory } from 'react-router-dom';
import styles from './library.module.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { opacity, rows } from 'constants/table';
import { useTranslation } from 'react-i18next';
import { getFullPathOrHome } from 'utils/paths';

export default function TableSkeleton() {
  const history = useHistory();
  const { t } = useTranslation();

  const onClick = () => {
    history.push(getFullPathOrHome());
  };

  return (
    <div className={styles.skeleton_container}>
      <div className={styles.skeleton__text_container}>
        <AddCircleOutlineIcon className={styles.skeleton__add_icon} />
        <span>{t('library.noRecord')}</span>
        <span>{t('library.getStarted')}</span>
        <Button
          data-testid="CreateNewButton"
          className={styles.create_new_button}
          startIcon={<AddCircleOutlineIcon />}
          size="medium"
          variant="contained"
          onClick={onClick}
          disableRipple>
          {t('library.createNew')}
        </Button>
      </div>
      <Table
        sx={{
          pointerEvents: 'none',
        }}
        className={styles.library__table}
        aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{t('library.companyName')}</TableCell>
            <TableCell>{t('library.projectName')}</TableCell>
            <TableCell>{t('library.owner')}</TableCell>
            <TableCell>{t('library.lastModified')}</TableCell>
            <TableCell>{t('library.dateCreated')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((_, idx) => {
            return (
              <TableRow key={`item_${idx}`} sx={{ opacity: opacity[idx] }}>
                <TableCell>
                  <div className={styles.library__table_content}></div>
                </TableCell>
                <TableCell>
                  <div className={styles.library__table_content}></div>
                </TableCell>
                <TableCell>
                  <div className={styles.library__table_content}></div>
                </TableCell>
                <TableCell>
                  <div className={styles.library__table_content}></div>
                </TableCell>
                <TableCell>
                  <div className={styles.library__table_content}></div>
                </TableCell>
                <TableCell>
                  <button>
                    <ArrowForwardIosIcon />
                  </button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
